module.exports = __webpack_public_path__ + "img/cpm158.866cf608.jpg";